const initialState = {
    error: null,
    data: {
        locked: true,
        backedUp: undefined,
    },
};
export default initialState;
